import React, { PropsWithChildren } from 'react';

import Section from '@rover/kibble/patterns/Section';

import type { PageChromeProps } from './PageChrome.common';

/**
 * Web: the browser scrolls the page, so the content only needs to be centred and
 * width-capped. The native counterpart supplies its own scroll region and keyboard
 * avoidance instead.
 */
const PageChrome = ({ isEmbedded, children }: PropsWithChildren<PageChromeProps>): JSX.Element => (
  // An embedding host has already placed and padded the content, so the page's own
  // vertical rhythm would read as a gap inside the frame.
  <Section
    maxWidth="560px"
    my={isEmbedded ? '0x' : ['8x', '16x']}
    data-testid="email-verification-page"
  >
    {children}
  </Section>
);

export default PageChrome;
